const FeatureInsights = () => {
    return (
        <section className="py-24 w-full">
            <div className="container mx-auto px-4 md:px-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-20 items-center">
                    <div className="order-2 md:order-1">
                        <div className="inline-block bg-optibiz-yellow/20 dark:bg-optibiz-yellow/30 text-yellow-800 dark:text-yellow-400 text-xs font-bold px-3 py-1 rounded-full mb-4">
                            Analytics
                        </div>
                        <h2 className="text-4xl md:text-5xl font-extrabold text-tasktide-dark dark:text-white mb-8 leading-tight">
                            Make Data-Driven Business Decisions
                        </h2>
                        <p className="text-gray-500 dark:text-gray-400 text-lg mb-10 leading-relaxed">
                            Access real-time analytics and insights across all your business operations. Understand customer behavior, employee performance, sales trends, and financial health all in one place.
                        </p>
                    </div>

                    <div className="order-1 md:order-2 relative pl-0 md:pl-8">
                        {/* Yellow Background Card */}
                        <div className="bg-optibiz-yellow dark:bg-optibiz-yellow/90 rounded-[3rem] p-8 md:p-12 relative overflow-hidden shadow-2xl group">
                            <div className="relative z-10 bg-white dark:bg-gray-800 rounded-[2rem] overflow-hidden shadow-lg transform rotate-[2deg] group-hover:rotate-0 transition-transform duration-500 border border-gray-100 dark:border-gray-700">
                                <img
                                    src="https://images.pexels.com/photos/6285080/pexels-photo-6285080.jpeg"
                                    alt="Analytics"
                                    className="w-full h-64 object-cover"
                                />
                                <div className="p-6">
                                    <div className="flex items-center justify-between mb-4">
                                        <div className="text-sm font-bold text-gray-600 dark:text-gray-300">Weekly Report</div>
                                        <div className="text-xs font-bold text-optibiz-green bg-green-50 dark:bg-green-900/30 px-2 py-1 rounded">+12% vs last week</div>
                                    </div>
                                    <div className="flex items-end gap-2 h-16">
                                        <div className="w-1/5 bg-gray-100 dark:bg-gray-700 rounded-t-lg h-1/2"></div>
                                        <div className="w-1/5 bg-gray-100 dark:bg-gray-700 rounded-t-lg h-3/4"></div>
                                        <div className="w-1/5 bg-optibiz-yellow dark:bg-optibiz-yellow/90 rounded-t-lg h-full"></div>
                                        <div className="w-1/5 bg-gray-100 dark:bg-gray-700 rounded-t-lg h-2/3"></div>
                                        <div className="w-1/5 bg-gray-100 dark:bg-gray-700 rounded-t-lg h-1/3"></div>
                                    </div>
                                </div>
                            </div>

                            {/* Floating Badge */}
                            <div className="absolute top-4 left-4 sm:top-8 sm:left-8 bg-white dark:bg-gray-800 p-3 rounded-xl shadow-lg animate-bounce delay-1000 z-20 border border-gray-100 dark:border-gray-700">
                                <div className="flex items-center gap-2">
                                    <div className="w-8 h-8 rounded-full bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center text-optibiz-purple font-bold">
                                        i
                                    </div>
                                    <div className="text-xs font-bold">
                                        <div className="text-gray-500 dark:text-gray-300">Insight</div>
                                        <div className="text-tasktide-dark dark:text-white">On Track</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FeatureInsights;
